export default [
    {
        path: '/request/part-replacements',
        name: 'request-part-replacements',
        props: true,
        component: () => import('@/views/request/part-replacements/index.vue'),
        meta: {
            pageTitle: 'Penggantian Ban & Aki',
            breadcrumb: [
                {
                text: 'Penggantian Ban & Aki',
                active: true,
                },
            ],
        },
    },
    {
        path: '/request/part-replacement/:id',
        name: 'detail-part-replacement',
        props: true,
        component: () => import('@/views/request/part-replacements/detail.vue'),
        meta: {
            pageTitle: 'Penggantian Ban & Aki',
            breadcrumb: [
                {
                text: 'Penggantian Ban & Aki',
                to: { name: 'request-part-replacements' },
                },
                {
                text: 'Detail Penggantian Ban & Aki',
                active: true,
                },
            ],
        },
    },
]